<div class="notes-actions">
    <ng-content></ng-content>
    <span
        class="ham-icon eye-icon"
        stopPropagation
        [ngClass]="{ 'slash-through': isHidden }"
        hamTooltip="{{
            isHidden
                ? ('aumico_notes_components_list_actions_show_component_tooltip' | i18next)
                : ('aumico_notes_components_list_actions_hide_component_tooltip' | i18next)
        }}"
        tooltipPosition="bottom"
        (click)="onVisibilityToggle()"
    >
        <i class="eye-icon"></i>
    </span>
    <span
        *ngIf="hasCopyButton == true"
        class="ham-icon page-break-icon"
        (click)="onCopy()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_copy_tooltip' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="copy2-icon action-icon"></i>
    </span>
    <span *ngIf="hasCopyButton == true" class="palette-spacer"> &nbsp; </span>
    <span
        *ngIf="isEditing && hasFootnoteButton == true"
        class="ham-icon table-icon"
        [ngClass]="{ on: hasFootnotes }"
        (click)="onFootnote()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_footnote_tooltip' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="frame-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && pageBreak != null"
        class="ham-icon page-break-icon"
        [ngClass]="{ on: pageBreak }"
        (click)="onPageBreak()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_break_page_tooltip' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="page-break-outline-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && settings != null"
        class="ham-icon"
        [ngClass]="{ on: settings }"
        (click)="toggleSettings()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_settings' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="settings-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && hasAddButton !== false"
        class="ham-icon"
        (click)="onAdd()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_add' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="circle-plus action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && showPreviousYear != null"
        class="ham-icon transpose-icon"
        [ngClass]="{ on: showPreviousYear }"
        (click)="onShowPreviousYear()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_show_previous_year' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="previous-year-outline-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && transpose != null"
        class="ham-icon table-icon"
        [ngClass]="{ on: !compareYears || showFiscalYear || hideCurrentYear }"
        (click)="onTableFlyout($event)"
        hamTooltip="{{ 'aumico_notes_components_list_actions_table_tooltip' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="table-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && transpose != null"
        class="ham-icon transpose-icon"
        [ngClass]="{ on: transpose }"
        (click)="onTranspose()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_transpose' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="rotate-90-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && flipSign != null"
        class="ham-icon flip-sign-icon"
        [ngClass]="{ on: flipSign }"
        (click)="onFlipSign()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_flip_signs' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="expense-position-outline-icon action-icon"></i>
    </span>
    <span
        *ngIf="isEditing && hasTotalRowButton"
        class="ham-icon total-sign-icon"
        [ngClass]="{ on: totalRow }"
        (click)="onTotalSign()"
        hamTooltip="{{ 'aumico_notes_components_list_actions_show_total' | i18next }}"
        tooltipPosition="bottom"
        stopPropagation
    >
        <i class="sigma-icon action-icon"></i>
    </span>
    <span *ngIf="!isEditing && hasEditButton" class="ham-icon edit-icon" (click)="onEdit()" stopPropagation>
        <i class="edit-icon-24 action-icon"></i>
    </span>

    <span
        *ngIf="isEditing && hasSaveButton"
        class="ham-icon save-icon"
        stopPropagation
        [ngClass]="{ disabled: isSaveDisabled }"
        (click)="onSave()"
    >
        <i class="floppy-outline-icon action-icon"></i>
    </span>

    <span *ngIf="hasDeleteButton == true" class="palette-spacer"> &nbsp; </span>
    <span
        *ngIf="hasDeleteButton"
        class="ham-icon"
        stopPropagation
        hamTooltip="{{ 'aumico_button_delete' | i18next }}"
        tooltipPosition="bottom"
        (click)="onDelete()"
    >
        <i class="trash-outline-24-icon action-icon"></i>
    </span>
</div>
<!-- Table Flyout Content -->
<div
    class="notes-action-palette-table-flyout"
    hamFlyout
    *ngIf="isTableFlyoutOpen"
    [position]="flyoutPosition"
    (closeFlyout)="closeTableFlyout()"
>
    <div class="flyout-content">
        <div class="flyout-body">
            <div class="flyout-header">{{ 'aumico_notes_action_palette_column_label_name' | i18next }}</div>
            <div class="context-option" *ngIf="compareYears != null" style="padding-bottom: 0; padding-top: 0">
                <div class="radio-group">
                    <label>
                        <input
                            type="radio"
                            name="dateDisplay"
                            [checked]="(internalShowFiscalYear ?? showFiscalYear) === true"
                            (change)="onShowFiscalYear()"
                        />
                        {{ 'aumico_notes_action_palette_column_label_show_fiscal_year' | i18next }}
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="dateDisplay"
                            [checked]="(internalShowFiscalYear ?? showFiscalYear) !== true"
                            (change)="onShowBalanceSheetDate()"
                        />
                        {{ 'aumico_notes_action_palette_column_label_show_balance_sheet_date' | i18next }}
                    </label>
                </div>
            </div>
            <div class="divider"></div>
            <div class="flyout-header">{{ 'aumico_notes_action_palette_column_label_hide_column' | i18next }}</div>
            <div class="context-option" *ngIf="compareYears != null">
                <label>
                    <input type="checkbox" [checked]="!compareYears" (click)="onCompareYears($event)" />
                    {{ getPreviousYearLabel()
                    }}<ng-container *ngIf="fxDisplayCurrency != null">
                        · {{ annualReportDefaultSettings?.currency }}</ng-container
                    >
                </label>
            </div>
            <!-- FX (REV-21512): display-currency twin columns, hideable like their functional originals -->
            <div class="context-option" *ngIf="fxDisplayCurrency != null">
                <label>
                    <input type="checkbox" [checked]="fxHidePreviousYear === true" (click)="onFxHidePreviousYear()" />
                    {{ getPreviousYearLabel() }} · {{ fxDisplayCurrency }}
                </label>
            </div>
            <div class="context-option" *ngIf="compareYears != null">
                <label>
                    <input type="checkbox" [checked]="hideCurrentYear" (click)="onHideCurrentYear($event)" />
                    {{ getCurrentYearLabel()
                    }}<ng-container *ngIf="fxDisplayCurrency != null">
                        · {{ annualReportDefaultSettings?.currency }}</ng-container
                    >
                </label>
            </div>
            <div class="context-option" *ngIf="fxDisplayCurrency != null">
                <label>
                    <input type="checkbox" [checked]="fxHideCurrentYear === true" (click)="onFxHideCurrentYear()" />
                    {{ getCurrentYearLabel() }} · {{ fxDisplayCurrency }}
                </label>
            </div>
            <ng-container *ngIf="compareYears != null">
                <div class="divider"></div>
                <div class="flyout-header">{{ 'aumico_notes_action_palette_column_label_currency' | i18next }}</div>
                <div class="context-option" style="display: flex; justify-content: space-between; align-items: center;">
                    <span>{{ 'aumico_notes_super_table_show_currency' | i18next }}</span>
                    <ham-toggle
                        [checked]="(internalShowCurrency ?? showCurrency) === true"
                        (changed)="onShowCurrency($event)"
                    ></ham-toggle>
                </div>
            </ng-container>
        </div>
    </div>
</div>
